/**
 * Chaikin Oscillator
 *
 * Momentum of the Accumulation/Distribution line.
 * Chaikin = EMA(ADL, fast) − EMA(ADL, slow)
 *
 * Category: Volume | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";
import { computeEMA } from "./sma";

export const chaikinIndicator: IndicatorDefinition = {
  id: "chaikin",
  name: "Chaikin Oscillator",
  shortName: "CHO",
  category: "volume",
  pane: "separate",
  params: [
    { key: "fast", label: "Fast Period", type: "number", default: 3, min: 1, max: 50 },
    { key: "slow", label: "Slow Period", type: "number", default: 10, min: 2, max: 200 },
    { key: "color", label: "Color", type: "color", default: "#4CAF50" },
  ],
  plots: [
    { key: "chaikin", label: "Chaikin", color: "#4CAF50", style: "line", lineWidth: 2, priceScaleId: "chaikin" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { fast, slow } = params;
    const data: { time: number; value: number }[] = [];

    // Build ADL
    const adl: number[] = [];
    let cumAdl = 0;
    for (let i = 0; i < candles.length; i++) {
      const hl = candles[i].high - candles[i].low;
      const clv = hl === 0 ? 0 : ((candles[i].close - candles[i].low) - (candles[i].high - candles[i].close)) / hl;
      cumAdl += clv * (candles[i].volume || 0);
      adl.push(cumAdl);
    }

    const emaFast = computeEMA(adl, fast);
    const emaSlow = computeEMA(adl, slow);

    for (let i = 0; i < candles.length; i++) {
      if (!isNaN(emaFast[i]) && !isNaN(emaSlow[i])) {
        data.push({ time: candles[i].time, value: emaFast[i] - emaSlow[i] });
      }
    }

    return [{ key: "chaikin", data }];
  },
};
